import { STATUS_LABELS } from "@/lib/api";

const TONES = {
  emerald: "bg-emerald-50 text-emerald-700 ring-emerald-600/20",
  amber: "bg-amber-50 text-amber-700 ring-amber-600/20",
  red: "bg-red-50 text-red-700 ring-red-600/20",
  gray: "bg-gray-100 text-gray-600 ring-gray-500/20",
  blue: "bg-sky-50 text-sky-700 ring-sky-600/20",
};

const MAP = {
  active: "emerald", running: "emerald", sent: "emerald", completed: "blue",
  warming: "amber", pending: "amber", scheduled: "amber", sending: "amber",
  paused: "amber", disconnected: "red", banned: "red", failed: "red",
  opted_out: "red", invalid: "red", bounced: "red", blocked: "red",
  draft: "gray", cancelled: "gray", skipped: "gray",
};

export const StatusBadge = ({ status, label, testId }) => {
  const tone = TONES[MAP[status] || "gray"];
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset ${tone}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {label || STATUS_LABELS[status] || status}
    </span>
  );
};

export const Gauge = ({ value, max, label, testId }) => {
  const pct = max > 0 ? Math.min(100, (value / max) * 100) : 0;
  const color = pct >= 95 ? "bg-red-500" : pct >= 75 ? "bg-amber-500" : "bg-emerald-500";
  return (
    <div data-testid={testId}>
      <div className="flex items-baseline justify-between mb-1.5">
        <span className="text-xs text-gray-500">{label}</span>
        <span className="mono text-xs font-medium text-gray-800">{value}/{max}</span>
      </div>
      <div className="gauge-track">
        <div className={`gauge-fill ${color}`} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
};
